import { message } from 'antd';
import { takeLatest, put } from 'redux-saga/effects';
import { fetchAllTeams } from 'collections/teams';
import { RolesApi } from 'data/roles';
import { rolesCollection } from 'collections/roles';
import { invalidateMembersCaches } from 'queries/members';
import { updateMemberAction } from '../actions';
import { MembersAPI } from '../api';
import { updateMember } from '../slice';
function* updateMembers(payload, handleSuccess) {
    const users = yield MembersAPI.updateMember(payload);
    yield put(updateMember(users));
    if (handleSuccess) {
        handleSuccess(users);
    }
    // After the success callback, never before it: this kicks off a refetch of
    // the full members payload and the caller should not wait on it to show its
    // toast. Redux alone is not enough — the payload behind every
    // useGetAll*UsersMap consumer is cached and would keep the old name/role.
    yield invalidateMembersCaches();
}
function* updateMembersSaga(action) {
    const { payload: { data, role, handleAlways = ()=>{}, handleSuccess, handleFailure = ()=>{} } } = action;
    try {
        let payload = data[0];
        if (role.isNew) {
            try {
                const createdRole = yield RolesApi.createWithDefaultPlaceholder({
                    roleName: role.value
                });
                rolesCollection.push([
                    createdRole
                ], {
                    source: 'mutation'
                });
                try {
                    yield fetchAllTeams();
                } catch (unused) {
                // best-effort: teams collection hydration failed; role was created, continue with member update
                }
                payload = {
                    ...payload,
                    user: {
                        ...payload.user,
                        role: createdRole,
                        defaultCapacity: payload.user.defaultCapacity,
                        capacityMinutes: payload.user.capacityMinutes
                    }
                };
                yield updateMembers(payload, handleSuccess);
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            } catch (error) {
                message.error('Creating a new role failed');
                handleFailure();
            }
        } else {
            yield updateMembers(payload, handleSuccess);
        }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    } catch (error) {
        handleFailure();
    }
    handleAlways();
}
export const watchUpdateMembersSaga = function*() {
    yield takeLatest(updateMemberAction.type, updateMembersSaga);
};
